<div class="container">
  <div id="tutorial" *ngIf="!loggedUser">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="card mb-3">
                  <div class="row no-gutters">
                        <div class="card-div mx-auto">
                          <button class="btn green-button w-100" [routerLink]="'/tutorial-video/'">Hogyan működik? TUTORIAL videó</button>
                        </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>
    <div class="text-center">
        <p class="p-pos">Előfizetés </p>
    </div>
    <div id="kurzusaim" *ngIf="loggedUser && activeItems.length > 0">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                      <div class="row no-gutters">
                            <div class="card-div mx-auto">
                                <p class="card-title p-2">Aktív előfizetéseim</p>

                                <div class="card-body" *ngFor="let item of activeItems">
                                  <div class="course-title" style="position:relative;">
                                    <span class="card-text-name">{{ item.title }}</span>
                                    <ng-container *ngIf="!item.videostore">
                                      <button class="btn bcolor"
                                            [routerLink]="'/kurzusok/' + item.link">Foglalkozások megnyitása</button>
                                    </ng-container>
                                    <ng-container *ngIf="item.videostore">
                                      <div style="display:flex; flex-direction:column; gap: 5px">
                                        <button class="btn bcolor"
                                            [routerLink]="'/u/videotar_elofizetett'">Videótár megnyitása</button>

                                      </div>

                                    </ng-container>
                                  </div>
                                  <div style="display:flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom:1rem;">
                                    <p class="card-text pt-1 mb-0" *ngIf="item.cancellable && !item.free">Megújul: {{item.end_date}} <br/> Regisztrált kártya: {{ item.registered_card }}</p>
                                    <button *ngIf="item.cancellable && item.videostore && !item.free" class="btn bgreencolor"
                                    (click)="openModal('cancel-recurring-videostore', item.licenseUuid)">Előfizetés lemondása</button>
                                    <button *ngIf="item.cancellable && !item.videostore" class="btn bgreencolor"
                                    (click)="openModal('cancel-recurring', item.licenseUuid)">Előfizetés lemondása</button>
                                      <p class="card-text pt-1 mb-0" *ngIf="!item.cancellable && !item.licenseUuid && item.end_date">Hozzáférés vége: {{item.end_date}}</p>
                                      <p class="card-text pt-1 mb-0" *ngIf="!item.cancellable && item.licenseUuid">Az előfizetést lemondtad, a hozzáférés vége: {{item.end_date}}</p>
                                  </div>
                                    <div class="description" *ngIf="item.desc">
                                      <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="item.desc"></p>
                                      <p class="card-text" [innerHTML]="item.desc" [class.truncated-text]="item.isTextOverflow"></p>
                                      <p class="read-more-button text-right" *ngIf="isTextOverflowing(item, measureContainer)" (click)="toggleTextOverflow(item)">{{ item.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                    </div>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="kurzusaim-inactive" *ngIf="loggedUser && !(activeItems.length > 0)">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="card-div mx-auto">
                                <p class="card-title p-2">Aktív előfizetéseim</p>
                                <div class="card-body">
                                    <p class="card-text-name">Jelenleg nincs előfizetésed.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="erdekel" *ngIf="loggedUser"> 
       <!-- && !hasProm -->
      <div class="container borders">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-3">
              <div class="row no-gutters">
                <div class="card-div mx-auto">
                  <p class="card-title p-2">Ez is érdekelhet</p>

                  <ng-container *ngFor="let item of items">
                    <div class="card-body" *ngIf="!isCourseActive(item.sku)">
                      <div class="course-title">
                        <span class="card-text-name">{{ item.title }}</span>

                        <!-- Button variations -->
                        <button class="btn bcolor"
                          [ngClass]="{
                              'disabled': !item.extension && (
                                item.alreadyHasLicense ||
                                item.similarLicense ||
                                item.excluded
                              )
                            }"

                          [disabled]="!item.extension && (
                              item.alreadyHasLicense ||
                              item.similarLicense ||
                              item.excluded
                            )"

                          (click)="addCart(item.type, item.type_id)">

                          <!-- EXTENSION OVERRIDES EVERYTHING -->
                          <ng-container *ngIf="item.extension">
                            Előfizetek
                          </ng-container>

                          <!-- NORMAL LOGIC -->
                          <ng-container *ngIf="!item.extension">

                            <ng-container *ngIf="item.alreadyHasLicense || item.similarLicense">
                              <ng-container *ngIf="item.isVideo">
                                Van aktív videótárad
                              </ng-container>
                              <ng-container *ngIf="!item.isVideo">
                                Van aktív előfizetésed
                              </ng-container>
                            </ng-container>

                            <ng-container *ngIf="!(item.alreadyHasLicense || item.similarLicense)">
                              Előfizetek
                            </ng-container>

                          </ng-container>
                        </button>
                      </div>

                      <p class="card-text">Ár: {{ item.price }}</p>
                      <p class="card-text">Előfizetés hossza: {{ item.month }}</p>

                      <div class="description" *ngIf="item.desc">
                        <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="item.desc"></p>
                        <p class="card-text" [innerHTML]="item.desc" [class.truncated-text]="item.isTextOverflow"></p>
                        <p class="read-more-button text-right"
                          *ngIf="isTextOverflowing(item, measureContainer)"
                          (click)="toggleTextOverflow(item)">
                          {{ item.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}
                        </p>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="erdekel" *ngIf="loggedUser && !this.hasProm">
        <div class="container borders">

            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="card-div mx-auto">
                              <p class="card-title p-2">Ez is érdekelhet</p>
                              <ng-container *ngFor="let courseNonExpires of productsForLicens">
                                <ng-container *ngIf="!isCourseActive(courseNonExpires.sku)">
                                    <div class="card-body">
                                      <div class="course-title">
                                        <span class="card-text-name">{{ courseNonExpires.title }}</span>
                                        <button class="btn bcolor"
                                        (click)="addCart(courseNonExpires.type, courseNonExpires.type_id)">Előfizetek</button>
                                      </div>

                                        <p class="card-text">Ár:
                                          {{ courseNonExpires.price }}
                                        </p>
                                        <p class="card-text">Előfizetés hossza: {{courseNonExpires.month}}
                                        </p>
                                        <div class="description" *ngIf="courseNonExpires.desc">
                                          <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="courseNonExpires.desc"></p>
                                          <p class="card-text" [innerHTML]="courseNonExpires.desc" [class.truncated-text]="courseNonExpires.isTextOverflow"></p>
                                          <p class="read-more-button text-right" *ngIf="isTextOverflowing(courseNonExpires, measureContainer)" (click)="toggleTextOverflow(courseNonExpires)">{{ courseNonExpires.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
                <!-- Egyéb videótéka termékek 
        <div class="container borders">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="row no-gutters">
                            <div class="card-div mx-auto">

                                <div class="card-body"
                                *ngFor="let courseNonExpires of productsVidForLicens">
                                <div class="course-title">
                                  <span class="card-text-name">{{ courseNonExpires.title }}</span>
                                  <button class="btn bcolor" [ngClass]="{'disabled': courseNonExpires.alreadyHasLicense}" [disabled]="courseNonExpires.alreadyHasLicense"
                                  (click)="addCart(courseNonExpires.type, courseNonExpires.type_id)">
                                  <ng-container *ngIf="!courseNonExpires.alreadyHasLicense">
                                    Előfizetek
                                  </ng-container>
                                  <ng-container *ngIf="courseNonExpires.alreadyHasLicense">
                                    Van aktív videótárad
                                  </ng-container>
                                </button>
                                </div>
                                <p class="card-text">Ár: {{ courseNonExpires.price }}</p>
                                <p class="card-text">Előfizetés hossza: {{courseNonExpires.month}}</p>
                                <div class="description" *ngIf="courseNonExpires.desc">
                                  <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="courseNonExpires.desc"></p>
                                  <p class="card-text" [innerHTML]="courseNonExpires.desc" [class.truncated-text]="courseNonExpires.isTextOverflow"></p>
                                  <p class="read-more-button text-right" *ngIf="isTextOverflowing(courseNonExpires, measureContainer)" (click)="toggleTextOverflow(courseNonExpires)">{{ courseNonExpires.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>



      </div>
        <!--videótéka termékek

        <div class="container">
            <div class="row" *ngIf="secondaryProductsForLicens.length > 0">
              <div class="col-md-12">
                  <div class="card mb-3">
                      <div class="row no-gutters">
                          <div class="card-div mx-auto">
                            <ng-container *ngFor="let courseNonExpires of secondaryProductsForLicens">
                              <ng-container *ngIf="!isCourseActive(courseNonExpires.sku)">
                                  <div class="card-body">
                                    <div class="course-title">
                                      <span class="card-text-name">{{ courseNonExpires.title }}</span>
                                      <button class="btn bcolor" [ngClass]="{'disabled': courseNonExpires.alreadyHasLicense || courseNonExpires.excluded}" [disabled]="courseNonExpires.alreadyHasLicense || courseNonExpires.excluded"
                                      (click)="addCart(courseNonExpires.type, courseNonExpires.type_id)">
                                      <ng-container *ngIf="!courseNonExpires.alreadyHasLicense">
                                        Előfizetek
                                      </ng-container>
                                      <ng-container *ngIf="courseNonExpires.alreadyHasLicense">
                                        Van aktív előfizetésed
                                      </ng-container>
                                    </button>
                                    </div>

                                      <p class="card-text">Ár:
                                        {{ courseNonExpires.price }}
                                      </p>
                                      <p class="card-text">Előfizetés hossza: {{courseNonExpires.month}}
                                      </p>
                                      <div class="description" *ngIf="courseNonExpires.desc">
                                        <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="courseNonExpires.desc"></p>
                                        <p class="card-text" [innerHTML]="courseNonExpires.desc" [class.truncated-text]="courseNonExpires.isTextOverflow"></p>
                                        <p class="read-more-button text-right" *ngIf="isTextOverflowing(courseNonExpires, measureContainer)" (click)="toggleTextOverflow(courseNonExpires)">{{ courseNonExpires.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                      </div>
                                  </div>
                              </ng-container>
                          </ng-container>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

        </div>



        <!-- Egyéb termékek 
        <div class="container">
                    <div class="row">
              <div class="col-md-12">
                  <div class="card">
                      <div class="row no-gutters">
                          <div class="card-div mx-auto">
                              <div class="card-body"
                              *ngFor="let courseNonExpires of secondaryProductsVidForLicens">
                              <div class="course-title">
                                <span class="card-text-name">{{ courseNonExpires.title }}</span>
                                <button class="btn bcolor" [ngClass]="{'disabled': courseNonExpires.alreadyHasLicense}" [disabled]="courseNonExpires.alreadyHasLicense"
                                (click)="addCart(courseNonExpires.type, courseNonExpires.type_id)">
                                <ng-container *ngIf="!courseNonExpires.alreadyHasLicense">
                                  Előfizetek
                                </ng-container>
                                <ng-container *ngIf="courseNonExpires.alreadyHasLicense">
                                  Van aktív videótárad
                                </ng-container>
                              </button>
                              </div>
                              <p class="card-text">Ár: {{ courseNonExpires.price }}</p>
                              <p class="card-text">Előfizetés hossza: {{courseNonExpires.month}}</p>
                              <div class="description" *ngIf="courseNonExpires.desc">
                                <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="courseNonExpires.desc"></p>
                                <p class="card-text" [innerHTML]="courseNonExpires.desc" [class.truncated-text]="courseNonExpires.isTextOverflow"></p>
                                <p class="read-more-button text-right" *ngIf="isTextOverflowing(courseNonExpires, measureContainer)" (click)="toggleTextOverflow(courseNonExpires)">{{ courseNonExpires.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                              </div>
                          </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div> -->
    <div id="preview" *ngIf="isAdmin">
      <div class="container">
          <div class="row">
              <div class="col-md-12">
                  <div class="card mb-3">
                      <div class="row no-gutters">
                          <div class="card-div mx-auto">
                              <p class="card-title p-2">Kurzus előnézet</p>
                                      <div class="card-body" *ngFor="let preview of coursePreviews">
                                          <div class="course-title">
                                            <span class="card-text-name">{{ preview.title }}</span>
                                            <button class="btn bcolor"
                                                  (click)="prev(preview)">Előnézet</button>
                                          </div>

                                          <p class="card-text">Ár:
                                            {{ preview.price }}
                                          </p>
                                          <p class="card-text">Előfizetés hossza: {{preview.month}}
                                          </p>
                                          <div class="description" *ngIf="preview.desc">
                                            <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="preview.desc"></p>
                                            <p class="card-text" [innerHTML]="preview.desc" [class.truncated-text]="preview.isTextOverflow"></p>
                                            <p class="read-more-button text-right" *ngIf="isTextOverflowing(preview, measureContainer)" (click)="toggleTextOverflow(preview)">{{ preview.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                          </div>
                                      </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div *ngIf="!loggedUser">
    <div class="container borders">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-div mx-auto">

              <ng-container *ngFor="let item of items">
                <div class="card-body">
                  <div class="course-title">
                    <p class="card-text-name">{{ item.title }}</p>

                    <!-- For non-logged-in: always link to /fizetes -->
                    <button routerLink="/fizetes" class="btn bcolor mt-3">
                      Előfizetek
                    </button>
                  </div>

                  <p *ngIf="item.list_price" class="card-text">Lista ár: {{ item.list_price }}</p>
                  <p class="card-text">Ár: {{ item.price }}</p>
                  <p class="card-text">Előfizetés hossza: {{ item.month }}</p>

                  <div class="description" *ngIf="item.desc">
                    <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="item.desc"></p>
                    <p class="card-text" [innerHTML]="item.desc"></p>
                    <p class="read-more-button text-right"
                      *ngIf="isTextOverflowing(item, measureContainer)"
                      (click)="toggleTextOverflow(item)">
                      {{ item.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}
                    </p>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- <div *ngIf="!loggedUser">
        <div class="container borders">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div>
                            <div class="card-div mx-auto">

                                <div class="card-body" *ngFor="let product of secondaryProductsForLicens">
                                  <div class="course-title">
                                    <p class="card-text-name">{{ product.title }}</p>
                                    <button routerLink="/fizetes" class="btn bcolor mt-3"
                                            (click)="addCart(product.type, product.type_id)">Előfizetek</button>
                                  </div>

                                    <p *ngIf="product.list_price" class="card-text">Lista ár: {{product.list_price}}</p>
                                    <p class="card-text">Ár: {{product.price}}</p>
                                    <p class="card-text">Előfizetés hossza: {{product.month}}
                                    <div class="description" *ngIf="product.desc">
                                      <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="product.desc"></p>
                                      <p class="card-text" [innerHTML]="product.desc"></p>
                                      <p class="read-more-button text-right" *ngIf="isTextOverflowing(product, measureContainer)" (click)="toggleTextOverflow(product)">{{ product.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                    </div>
                                </div>

                              <div class="card-body" *ngFor="let product of productsVidForLicens">
                                <div class="course-title">
                                  <p class="card-text-name">{{ product.title }}</p>
                                  <button routerLink="/fizetes" class="btn bcolor mt-3"
                                          (click)="addCart(product.type, product.type_id)">Előfizetek</button>
                                </div>

                                  <p *ngIf="product.list_price" class="card-text">Lista ár: {{product.list_price}}</p>
                                  <p class="card-text">Ár: {{product.price}}</p>
                                  <p class="card-text">Előfizetés hossza: {{product.month}}
                                  <div class="description" *ngIf="product.desc">
                                    <p class="card-text hidden-measure-container" #measureContainer [innerHTML]="product.desc"></p>
                                    <p class="card-text" [innerHTML]="product.desc"></p>
                                    <p class="read-more-button text-right" *ngIf="isTextOverflowing(product, measureContainer)" (click)="toggleTextOverflow(product)">{{ product.isTextOverflow ? 'TOVÁBB' : 'KEVESEBB' }}</p>
                                  </div>
                              </div>




                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div> -->
    <div class="overlay" *ngIf="showModal"></div>
    <div class="modal fade modalc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
        id="exampleModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form>
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                            (click)="closeModal()">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>{{ modalContent }}</div>
                    </div>

                    <div class="modal-footer" *ngIf="platform !== 'cancel-recurring' && platform !== 'cancel-recurring-videostore'">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"
                            (click)="closeModal()">Bezárás</button>
                    </div>
                    <div class="modal-footer" style="display:flex; justify-content: space-around;" *ngIf="platform == 'cancel-recurring' || platform == 'cancel-recurring-videostore'">
                      <button type="button" class="btn btn-primary c"
                          (click)="doModalAction()">{{ modalActionTitle }}</button>
                      <button type="button" class="btn btn-secondary" data-dismiss="modal"
                          (click)="closeModal()"> {{ modalCancelTitle }}</button>
                  </div>
                </form>
            </div>
        </div>
    </div>
</div>
